import { collectAssetReferencesFromRenderData } from '../shared/assetReferences'
import type { RenderData } from '../assetTypes'

const featuresRenderer = (_content: string) => `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body, #root {
        height: 100%;
        width: 100%;
      }
      body {
        margin: 0;
        background-color: #ffffff;
        color: #111827;
        font-family: 'Be Vietnam Pro', 'Muli', sans-serif;
      }
    </style>
  </head>
  <body>
    <div id="root"></div>
  </body>
</html>`

export const collectAssetReferences = (content: string, renderData?: RenderData) =>
  collectAssetReferencesFromRenderData(content, renderData)

export default featuresRenderer
